import { useSnackbar } from '../../components/providers/SnackbarProvider'
import useCallbackDebounced from './useCallbackDebounced'
import { useDownloadFileCallback } from './useDownloadFileCallback'
import { useQuery } from './useQuery'

export const useDownloadFile = ({ url, fileName }: { url: string; fileName: string }) => {
  const { showSuccess, showError } = useSnackbar()
  const { downloadFile } = useDownloadFileCallback()
  const { executeQuery, loadingRef, loading } = useQuery({
    query: () => fetch(url, { credentials: 'omit' }),
    transform: async data => {
      const blob = await data.blob()
      const url = URL.createObjectURL(blob)
      return { url }
    },
    onSuccess: ({ url }) => {
      downloadFile({ url, fileName })
      showSuccess(`Successfully downloaded ${fileName}`)
    },
    onError: () => {
      showError(`Failed to download ${fileName}`)
    },
  })
  const downloadFileHandler = useCallbackDebounced(() => {
    if (!loadingRef.current) {
      executeQuery()
    }
  }, [executeQuery, loadingRef])
  return { downloadFile: downloadFileHandler, loading }
}
